module.exports = __webpack_public_path__ + "static/media/wp3.5b49f07a.jpg";